import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import React from "react";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { useState } from "react";
import { posServices } from "../../Services/pos.service";

const ChangePosVersionModal = ({
  changeVersionModal,
  setChangeVersionModal,
  pos,
  posId
}) => {
  const { t: translator } = useTranslation();
  const { register, errors } = useForm();
  const [posVersions, setPosVersions] = useState();
  const [selectedVersion, setSelectedVersion] = useState();
  const [currentVersion, setCurrentVersion] = useState(false);

  const [modal, setModal] = useState({
      title: "",
      text: "",
      show: false,
      btnClass: "",
      success: true,
    });
  const [serverError, setServerError] = useState(null);

  useEffect(() => {
    if (!pos?.posVersion) return;
    posServices.getPosVersions(pos?.posVersion).then((res) => {
      console.log("rEZZ", res?.data);
      setPosVersions(res?.data);
    });
  }, [pos?.posVersion]);

  const handleSelectChange = (e) => {
    setSelectedVersion(e.target.value);

    const found = posVersions.find((posVer) => posVer.name === e.target.value);
    //setCurrentVersion(found.isCurrent === true);
  };

  const handleSave = () => {
    setChangeVersionModal(false);
    posServices
          .changePosVersion(
            posId,
            selectedVersion
          )
          .then((res) => {
            if (res.status === 200) {
              //handleHide();
              setModal({
                show: true,
                title: translator("ChangeVersion-SuccessModal-Title"),
                text: translator("ChangeVersion-SuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: true,
              });
            } else {
              setServerError(res.data.errors[0].value);
            }
          })
          .catch((err) => {
            setServerError(err);
          });
  };

  return (
    <>
      <Modal show={changeVersionModal} onHide={()=> setChangeVersionModal(false)} centered>
         
        <Modal.Header>
                <Modal.Title>{translator("PosChangeVersion-Title")}</Modal.Title>
              </Modal.Header>
        <Modal.Body>
        
            <div className="currentVersionCont">
              <label style={{textAlign:'center'}}>{translator("PosChangeVersion-CurrentVersion")}</label>
              <center>{pos?.posVersion}</center>
            </div>
            <div>
              <label>{translator("PosChangeVersion-SelectVersion")}</label>
              <select
                ref={register({ required: true })}
                className="form-control"
                defaultValue={0}
                name="versionId"
                onChange={handleSelectChange}
                value={selectedVersion}
              >
                <option value="">{translator("Select-Version")}</option>
                {posVersions?.map((posVer) => (
                  <option key={posVer?.id} value={posVer.id}>
                    {translator(posVer?.name)}
                  </option>
                ))}
              </select>
              {errors.noteId && errors.versionId.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
            </div>
        
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={() => setChangeVersionModal(false)}
            className="btn btn-outline-secondary"
          >
            {translator("Btn-Cancel")}
          </button>
          <Button
            disabled={currentVersion}
            onClick={()=>handleSave()}
            appearance="primary"
          >
            {translator("Btn-Save")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChangePosVersionModal;
